import React, { useState, useEffect } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import './SearchPhotos.css';

const API_URL = process.env.REACT_APP_API_URL;

const SearchPhotos = () => {
    const [budowa, setBudowa] = useState('');
    const [dates, setDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [query, setQuery] = useState('');
    const [error, setError] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);
    const [modalPhotos, setModalPhotos] = useState([]);

    const fetchDates = async () => {
        try {
            const queryParams = `budowa=${budowa}&year=${selectedDate.split('-')[0] || ''}&month=${selectedDate.split('-')[1] || ''}&day=${selectedDate.split('-')[2] || ''}&q=${query}`;
            const response = await fetch(`${API_URL}/api/list-dates?${queryParams}`);
            if (!response.ok) throw new Error('Nie znaleziono wyników dla wybranych kryteriów.');
            const data = await response.json();
            // Sortuj daty od najnowszej do najstarszej
            const sortedDates = data.sort((a, b) => new Date(b.date) - new Date(a.date));
            setDates(sortedDates);
            setError('');
        } catch (err) {
            setError(err.message);
            setDates([]);
        }
    };


    const handleBudowaChange = (e) => {
        setBudowa(e.target.value);
        setSelectedDate('');
        setDates([]);
        setActiveIndex(null);
    };

    const handleSearch = () => {
        if (budowa) {
            fetchDates();
        } else {
            setError('Wybierz budowę, aby rozpocząć wyszukiwanie.');
        }
    };

    const toggleSection = (index, photos) => {
        setActiveIndex(index === activeIndex ? null : index);
        setModalPhotos(photos || []);
    };

    const downloadZip = async (budowa, folderPath, date, id) => {
        const zip = new JSZip();
        const folderName = `${budowa}_${date.replaceAll('/', '_')}_${id}`;

        const cleanedFolderPath = folderPath.replace(/\\/g, '/');

        try {
            console.log("Pobieranie zdjęć dla folderu:", cleanedFolderPath);

            const response = await fetch(`${API_URL}/api/search-photos?folderPath=${encodeURIComponent(cleanedFolderPath)}`);
            if (!response.ok) throw new Error('Nie udało się pobrać zdjęć.');

            const photos = await response.json();
            console.log("Zdjęcia do pobrania:", photos);

            const opisResponse = await fetch(`${API_URL}/uploads/${cleanedFolderPath}/opis.txt`);
            if (opisResponse.ok) {
                const opisBlob = await opisResponse.blob();
                zip.file('opis.txt', opisBlob);
            } else {
                console.warn("Brak pliku opis.txt");
            }

            const dataResponse = await fetch(`${API_URL}/uploads/${cleanedFolderPath}/data.txt`);
            if (dataResponse.ok) {
                const dataBlob = await dataResponse.blob();
                zip.file('data.txt', dataBlob);
            } else {
                console.warn("Brak pliku data.txt");
            }

            const pdfResponse = await fetch(`${API_URL}/uploads/${cleanedFolderPath}/bilder.pdf`);
            if (pdfResponse.ok) {
                const pdfBlob = await pdfResponse.blob();
                zip.file('bilder.pdf', pdfBlob);
            } else {
                console.warn("Brak pliku bilder.pdf");
            }

            await Promise.all(
                photos.map(async (photo) => {
                    const photoResponse = await fetch(`${API_URL}/uploads/${photo.replace(/\\/g, '/')}`);
                    if (!photoResponse.ok) throw new Error('Błąd pobierania zdjęcia: ' + photo);
                    const blob = await photoResponse.blob();
                    const fileName = photo.split('/').pop();
                    zip.file(fileName, blob);
                })
            );

            const zipBlob = await zip.generateAsync({ type: "blob" });
            saveAs(zipBlob, `${folderName}.zip`);
            console.log("ZIP został pomyślnie pobrany:", `${folderName}.zip`);
        } catch (error) {
            console.error("Błąd podczas tworzenia pliku ZIP:", error);
        }
    };

    const downloadPdf = async (folderPath) => {
        try {
            const pdfResponse = await fetch(`${API_URL}/uploads/${folderPath}/bilder.pdf`);
            if (!pdfResponse.ok) throw new Error('Brak pliku PDF');
            const pdfBlob = await pdfResponse.blob();
            saveAs(pdfBlob, 'bilder.pdf');
        } catch (error) {
            console.error("Błąd podczas pobierania pliku PDF:", error);
        }
    };

    const openModal = (photoIndex) => {
        setSelectedPhotoIndex(photoIndex);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPhotoIndex(null);
    };

    const showNextPhoto = () => {
        setSelectedPhotoIndex((prevIndex) => (prevIndex + 1) % modalPhotos.length);
    };

    const showPreviousPhoto = () => {
        setSelectedPhotoIndex((prevIndex) => (prevIndex - 1 + modalPhotos.length) % modalPhotos.length);
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <div className="select-container">
                <select
                    value={budowa}
                    onChange={handleBudowaChange}
                    className="select-dropdown"
                >
                    <option value="">Baustelle Auswählen</option>
                    <option value="ahq">AHQ</option>
                    <option value="maxfreii">MaxFreii</option>
                </select>
            </div>

            {budowa && (
                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <label>
                        Datum<br />
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            className="date-picker"
                        />
                    </label>
                    <br />
                    <label>
                        Suchmaschine:<br />
                        <input
                            type="text"
                            placeholder="Beispiel... .7OG, Staubsauger..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            className="search-input"
                        />
                    </label>
                </div>
            )}

            <button onClick={handleSearch} className="search-button">Suchen</button>

            {error && <p style={{ color: 'red' }}>{error}</p>}

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                {dates.map((dateData, index) => (
                    <div key={index} className="date-entry">
                        <h3 onClick={() => toggleSection(index, dateData.photos)}>
                            Datum<br/> {dateData.date}
                        </h3>
                        {activeIndex === index && (
                            <div>
                                <p>Beschreibung<br /> {dateData.opis}</p>
                                <div className="button-container">
                                    <button onClick={() => downloadZip(budowa, dateData.folderPath, dateData.date, dateData.id)}>
                                         ZIP Download
                                    </button>
                                    <button onClick={() => downloadPdf(dateData.folderPath)}>
                                         PDF Download
                                    </button>
                                </div>
                                <div className="photo-gallery">
                                    {Array.isArray(dateData.photos) && dateData.photos.map((photo, photoIndex) => (
                                        <img
                                            key={photoIndex}
                                            src={`${API_URL}/uploads/${photo}`}
                                            alt={`Zdjęcie ${photoIndex + 1}`}
                                            className="photo-thumbnail"
                                            onClick={() => openModal(photoIndex)}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {isModalOpen && selectedPhotoIndex !== null && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="modal-close" onClick={closeModal}>&times;</span>
                        <button className="modal-arrow left" onClick={showPreviousPhoto}>&#10094;</button>
                        <img
                            src={`${API_URL}/uploads/${modalPhotos[selectedPhotoIndex]}`}
                            alt="Wybrane zdjęcie"
                            style={{ maxWidth: '100%', maxHeight: '90vh' }}
                        />
                        <button className="modal-arrow right" onClick={showNextPhoto}>&#10095;</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchPhotos;
